import 'regenerator-runtime/runtime'
import useBSSLogger from '../hooks/useBSSLogger';
import getapiclient, { getwpclient } from '../lib/ajaxhelper';
import {cancella, crea, modifica} from './std'

const {logger} = useBSSLogger();

const strentity = "ttipicolli";

/**
 * 
 * @returns le misure predefinite per utente
 */
const mappaTipiColli = async () => {
    const {data} = await getapiclient().get(`${strentity}/mappatipicollipredef`) 

    const mappatipicolli = data ?? {};

    logger.debug("ottenuti tipi colli", mappatipicolli)
    return mappatipicolli; 
}


const creaTipiColli = async (dati) => {
    return crea(strentity, dati)
}

const eliminaTipiColli = async (dati) => {
    return cancella(strentity, dati)
}

const modificaTipiColli = async (dati) => {
    return modifica(strentity, dati)
}

export {mappaTipiColli, creaTipiColli, eliminaTipiColli, modificaTipiColli}